(() => {
  'use strict';
  if (!/^ja(?:-|$)/i.test(document.documentElement.lang)) return;
  let imageMap = {};
  try { imageMap = JSON.parse(document.getElementById('vna-ja-image-map')?.textContent || '{}'); } catch (_) {}
  const nameOf = value => {
    try {
      return decodeURIComponent(new URL(value, location.href).pathname.split('/').pop())
        .replace(/_\d+x\d*(?=\.[^.]+$)/, '').toLowerCase();
    } catch (_) { return ''; }
  };
  const imageURL = value => imageMap[nameOf(value)] || value;
  const srcset = value => value.split(',').map(part => {
    const match = part.trim().match(/^(\S+)(\s+.*)?$/);
    return match ? imageURL(match[1]) + (match[2] || '') : part;
  }).join(', ');
  const isCollab = /\/pages\/collab\/?$/.test(location.pathname);
  const collabCopy = new Map([
    ['Join the Vernailiquea community', 'VNAのパートナープログラムに参加する'],
    ['Apply now', '応募する'], ['Already a member?', '登録済みの方'],
    ['Log in', 'ログイン'], ['Partnership opportunities', 'パートナーシップについて']
  ]);
  const controlCopy = new Map([
    ['Previous','前へ'],['Next','次へ'],['Close','閉じる'],
    ['Menu','メニュー'],['menu','メニュー'],['Open menu','メニューを開く'],
    ['Close menu','メニューを閉じる'],['Show More','もっと見る'],
    ['Show more','もっと見る'],['Back to top','ページの先頭へ']
  ]);
  function localizeText(node) {
    if (!node.parentElement || node.parentElement.closest('script,style,textarea,input,[contenteditable="true"]')) return;
    const value = node.nodeValue;
    const trimmed = value.trim().replace(/\s+/g, ' ');
    if (node.parentElement.closest('button,[role="button"]') && controlCopy.has(trimmed)) {
      node.nodeValue = value.replace(value.trim(), controlCopy.get(trimmed));
    } else if (isCollab && node.parentElement.closest('main') && collabCopy.has(trimmed)) {
      node.nodeValue = value.replace(value.trim(), collabCopy.get(trimmed));
    } else if (node.parentElement.closest('.jdgm-rev-widg__summary-text')) {
      const match = trimmed.match(/^(\d+)\s*レビュー$/);
      if (match) node.nodeValue = value.replace(value.trim(), `${match[1]}件のレビュー`);
    }
  }
  function localizeElement(el) {
    if (!(el instanceof Element)) return;
    for (const attr of ['aria-label','title']) {
      const value = el.getAttribute(attr);
      if (controlCopy.has(value)) el.setAttribute(attr,controlCopy.get(value));
    }
    if (el.matches('img,source,a,[data-src],[data-srcset],[data-image],[data-zoom-image]')) {
      for (const attr of ['src','data-src','data-image','data-zoom-image','href']) {
        const old = el.getAttribute(attr);
        if (!old || !/\.(?:png|webp|jpe?g|avif)(?:\?|$)/i.test(old)) continue;
        const next = imageURL(old);
        if (old !== next) el.setAttribute(attr,next);
      }
      for (const attr of ['srcset','data-srcset']) {
        const old = el.getAttribute(attr);
        if (old) { const next = srcset(old); if (next !== old) el.setAttribute(attr,next); }
      }
    }
    if (el.closest('.jdgm-widget,#judgeme_product_reviews')) {
      for (const attr of ['aria-label','title']) {
        if (el.getAttribute(attr) === 'Thumbnail Navigation') el.setAttribute(attr,'画像一覧');
      }
    }
  }
  function scan(node) {
    if (node.nodeType === Node.TEXT_NODE) { localizeText(node); return; }
    if (!(node instanceof Element) && node !== document) return;
    if (node instanceof Element) localizeElement(node);
    node.querySelectorAll?.('[aria-label],button,[role="button"],img,source,a,[data-src],[data-srcset],[data-image],[data-zoom-image],.jdgm-widget [aria-label],.jdgm-widget [title]').forEach(localizeElement);
    const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
    let text; while ((text=walker.nextNode())) localizeText(text);
  }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') localizeElement(record.target);
      else if (record.type === 'characterData') localizeText(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['src','srcset','data-src','data-srcset','data-image','data-zoom-image','href','aria-label','title']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});
  else scan(document);
})();
